export const CDN_URL = 'https://ploppin.nyc3.cdn.digitaloceanspaces.com'
export const SPACE_URL = 'https://ploppin.nyc3.digitaloceanspaces.com'

export const COLLECTIONS = {
    GENERATIONS: 'ploppin_generations',
    USERS: 'ploppin_users',
    EMAILS: 'ploppin_emails',
    ORDERS: 'ploppin_orders',
    DEMO: 'ploppin_demo'
}


export const STATUS = {
  PENDING: 'pending',
  PROCESSING: 'processing',
  COMPLETED: 'completed',
  FAILED: 'failed',
}
  

export const POLAR_BENEFITS = {
    CREDITS_240: 'c79a2bbb-55c6-4779-ad1e-2285e5eea05f',
    CREDITS_1400: '9d8b03d6-ba36-4e9f-87a0-c6c05e71525e'
}

export const POLAR_PRODUCTS = {
    PLUS: '9011f5c5-356f-4c51-b4c0-bf08e2b5d1a2',
    // PLUS: '363ff19a-9bf9-46fc-9098-5f24180ce389',
    PRO: '7525272b-1cfa-421b-9057-3ba521e80db7'
}


export const POLAR_SANDBOX_PRODUCTS = {
    PLUS: 'bedcf5d7-1870-4a25-ac18-4f1ed1c743bd',
    PRO: 'd0a63bd1-409b-4e36-a651-6478d0ae45d8'
}